import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { TipPopService } from '../services/tip-pop.service';

@Injectable({
  providedIn: 'root'
})
export class InitService {

  private http = inject(HttpClient)
  private tp = inject(TipPopService)

  /**
   * 发起POST请求
   * 
   * 本函数通过Angular的HttpClient模块发送一个POST请求，并返回请求的结果。
   * 使用泛型T和K来确保类型安全，其中T表示请求的数据类型，K表示返回的数据类型。
   * 
   * @param url 请求的URL
   * @param data 请求的数据
   * @param options 请求的选项，可选参数，用于配置请求的额外属性
   * @returns 返回一个Observable，订阅该Observable可以获取请求的响应数据
   */
  public post<T, K>(url: string, data: T, options?: any): Observable<K> {
    return this.http.post(url, data, options).pipe(map(response => {
      const resp = response as unknown as { code: number, data: K, err: string, total: number }
      if (resp.code !== 200) {
        // 请求失败提示
        this.tp.tipPop(resp.err, 'warning')
      }

      if (resp.total !== undefined) {
        return {
          data: resp.data,
          total: resp.total
        } as K
      } else {
        return resp.data as K
      }
    }))
  }

  /**
   * 文件上传公共接口
   * @param file 
   * @returns 
   */
  public file(file: File) {
    const formData = new FormData()
    formData.append("file", file)
    return this.http.post("/api/client/file/upload", formData).pipe(map(response => response))
  }
  
}
